import { render, staticRenderFns } from "./ExchangeRatesView.vue?vue&type=template&id=975b064e&scoped=true&"
import script from "./ExchangeRatesView.vue?vue&type=script&lang=js&"
export * from "./ExchangeRatesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975b064e",
  null
  
)

export default component.exports